import Template from "../../component/Template.js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Api from "../../component/Api.js";
import { Link } from "react-router-dom";
import React, { useRef } from "react";
import PDFModal from "../../component/PDFModal.js";
import ACA16_UserCreate from "./ACA16_UserCreate.js";
import Select from "react-select";

import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";

export default function ACA16_IPOVendorlist() {
  const tableRef = useRef(null);

  {
    /*------------------------------------*/
  }
  /* CUSTOM DATA TABLE BEGIN HERE */

  const [tableData, setTableData] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: "asc" }); //sort
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  const [reload, setReload] = useState(false);

  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [getCollegesData, setCollegesData] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState([]);
  const [selectedCollegeID, setselectedCollegeID] = useState(null);
  const [searchClicked, setSearchClicked] = useState(false);
  const [clearClicked, setClearClicked] = useState(false);

  /* CUSTOM DATA TABLE END HERE */

  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/admin/");
  }

  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");

  useEffect(() => {
    const fetchCollegeList = async () => {
      try {
        const response = await http.get("/Admin/getCollege");

        setCollegesData(response.data);
      } catch (error) {
        if (
          error.response?.data?.http_status === 403 &&
          error.response.data.status_code === "ERR37"
        ) {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);
        } else if (
          error.response?.data?.http_status === 429 &&
          error.response.data.status_code === "ERR33"
        ) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred.");
        }
      }
    };

    fetchCollegeList();
  }, [navigate]);

  const handleCollegeChange = (selectedOption) => {
    setSelectedCollege(selectedOption);
    setselectedCollegeID(selectedOption.value);
    console.log("selectedOption.value", selectedOption.value);

    setSearchClicked((prev) => !prev);
  };

  const showCourseList = () => {
    setSearchClicked((prev) => !prev); // toggle to re-trigger useEffect
  };

  const handleClearFields = () => {
    setSelectedCollege([]);
    setselectedCollegeID(null);
    setClearClicked((prev) => !prev);
  };
  useEffect(() => {
    const getCollegeUsersList = () => {
      http
        .post(`/Admin/listUniversityVendor`, {
          college_id: selectedCollegeID !== null ? selectedCollegeID : null,
        })
        .then((response) => {
          // console.log("res", response.data.data);
          setTableData(response.data.data);
        })
        .catch((error) => {
          const err = error.response?.data;

          if (err?.http_status === 401 && err?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);
          } else if (err?.http_status === 429 && err?.status_code === "ERR33") {
            toast.error(err.message);
          } else {
            toast.error("Something went wrong");
          }
        });
    };

    getCollegeUsersList();
  }, [searchClicked, clearClicked, reload]);

  /* DATA TABLE  For this page only */
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction:
        sortBy.column === column && sortBy.direction === "asc" ? "desc" : "asc",
    };
    setSortBy(newSortBy);
  };
  //sorting this page : combined column
  const getSortValue = (item, column) => {
    if (column === "vendor_details") {
      return `${item.vendor_name ?? ""} ${item.vendor_mobileno ?? ""} ${item.vendor_email ?? ""} ${item.vendor_address ?? ""}`.toLowerCase();
    }
    return (item[column] ?? "").toString().toLowerCase();
  };

  useEffect(() => {
    const search = searchQuery.toLowerCase();

    let data = [...tableData].filter(
      (item) =>
        (item.vendor_name ?? "").toLowerCase().includes(search) ||
        (item.vendor_email ?? "").toLowerCase().includes(search) ||
        (item.vendor_mobileno ?? "").toLowerCase().includes(search) ||
        (item.vendor_address ?? "").toLowerCase().includes(search) ||
        (item.college_name ?? "").toLowerCase().includes(search) ||
        (item.status ?? "").toLowerCase().includes(search),
    );

    //SORTING
    data.sort((a, b) => {
      const valA = getSortValue(a, sortBy.column);
      const valB = getSortValue(b, sortBy.column);

      if (sortBy.direction === "asc") {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;

    setfilteredAndSortedData(data.slice(startIndex, startIndex + itemsPerPage));
    setTotalPages(Math.ceil(data.length / itemsPerPage));
    setTotal(data.length);
  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === "asc" ? (
        <i className="fa fa-sort-up ml-1" aria-hidden="true"></i>
      ) : (
        <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>
      );
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get("/College/vendorListpdfDownload", {
        responseType: "blob", // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          "download",
          `InternshipProviderOrganisation_list.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success("PDF generated successfully");
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (
        error.response.data.http_status === 401 &&
        error.response.data.status_code == "ERR9"
      ) {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/admin/");
        }, 5000);
      } else if (
        error.response.data.http_status === 500 &&
        error.response.data.status_code == "ERR47"
      ) {
        toast.error(error.response.data.message);
      } else {
        console.error("Error generating PDF:", error);
        toast.error("Error generating PDF");
      }
    }
  };

  const handleDeleteUser = (userid) => {
    setDeleteUserID(userid);
    setDeleteUser(true);
  };

  const handleedit = (userid) => {
    navigate(`/admin/aca16_useredit/${userid}`);
  };
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  };

  const handleCloseCreateForm = () => {
    setShowCreateForm(false);
    setReload(!reload); // Refresh the list when closing
  };

  const handleViewDocument = async (encryptedFile) => {
    if (encryptedFile) {
      try {
        const res = await http.get(`College/secure_ino_pdf/${encryptedFile}`, {
          responseType: "blob",
        });

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        setPdfUrl(url);
        setIsPDFModalOpen(true);
      } catch (error) {
        console.error("Error loading PDF:", error);
        toast.error("Failed to load PDF document");
      }
    }
  };

  const handleClosePDFModal = () => {
    setIsPDFModalOpen(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  const handleDeleteSuccess = async () => {
    http
      .post("/Admin/deleteVendor", {
        id: deleteUserID,
      })
      .then((response) => {
        if (response.data.status_code === "MSG3") {
          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("User data deleted successfully");
          setReload(!reload);
        }
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error(
            "Deletion not allowed. The user has courses that are already approved.",
          );
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error(
            "Action not allowed after scripts have been received by your team.",
          );
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),
    option: (provided, state) => {
      const isSpecial = state.data.value === 0;

      return {
        ...provided,

        color: isSpecial ? "#782849" : "#222",
        fontWeight: isSpecial ? "600" : "normal",
        cursor: "pointer",
      };
    },
    singleValue: (provided, state) => {
      const isSpecial = state.data?.value === 0;

      return {
        ...provided,
        color: isSpecial ? "#782849" : "#000",
        fontWeight: isSpecial ? "600" : "500",
      };
    },
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      {showCreateForm ? (
        <ACA16_UserCreate onClose={handleCloseCreateForm} />
      ) : (
        <Template>
          <div className="container-fluid">
            <div className="row">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>
                          University Enlisted Internship Providing Organization
                        </h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <div className="card-body">
                          <div className="row align-items-end">
                            {/* SELECT BOX */}
                            {/* <div className="col-md-4">
                              <label>Select College</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="college_id"
                                name="college_id"
                                className="form"
                                styles={customStyles}
                                value={selectedCollege}
                                options={getCollegesData?.map((college) => ({
                                  value: college.college_id,
                                  label: college.college_name,
                                }))}
                                onChange={handleCollegeChange}
                              />
                            </div> */}

                            {/* BUTTONS */}
                            <div className="col-md-12 d-flex justify-content-end">
                              <div className="d-flex gap-2">
                              <button
                                className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                                onClick={() => setShowCreateForm(true)}
                                title="Add New User"
                              >
                                <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                              </button>
                              <button
                                className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                                onClick={handleGeneratePDFNew}
                                title="Download to PDF"
                              >
                                <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                              </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-8 wdt">
                            <p>
                              Showing {(currentPage - 1) * 50 + 1}
                              {""}-
                              {Math.min(
                                (currentPage - 1) * 50 + 50,
                                total_count,
                              )}{" "}
                              of {total_count} entries
                            </p>
                          </div>
                          <div className="col-md-4 wdt" align="right">
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={handleSearchInputChange}
                              placeholder="Search..."
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div
                          class="table-containerq"
                          style={{ overflowX: "unset" }}
                        >
                          <table
                            className="display dataTable table-striped table-bordered ex-v-table "
                            ref={tableRef}
                          >
                            <thead>
                              <tr className="bg-primary">
                                <th
                                  onClick={() => handleSort("id")}
                                  scope="col"
                                  data-label="APAAR Id"
                                  width="8%"
                                >
                                  Sl No &nbsp;
                                  {renderSortIcon("id")}{" "}
                                </th>

                                <th
                                  onClick={() => handleSort("vendor_details")}
                                  scope="col"
                                  data-label="User Type"
                                  width=""
                                >
                                  Name & <br />
                                  Contact Details &nbsp;
                                  {renderSortIcon("vendor_details")}{" "}
                                </th>

                                <th
                                  onClick={() => handleSort("college_name")}
                                  scope="col"
                                  data-label="User Type"
                                  width="30%"
                                >
                                  College &nbsp;
                                  {renderSortIcon("college_name")}{" "}
                                </th>

                                <th
                                  scope="col"
                                  data-label="Description"
                                  width=""
                                >
                                  Description
                                </th>

                                <th
                                  onClick={() => handleSort("done_by")}
                                  scope="col"
                                  data-label="User Type"
                                  width="15%"
                                >
                                  Done By &nbsp;
                                  {renderSortIcon("done_by")}{" "}
                                </th>

                                <th scope="col" data-label="Action" width="">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredAndSortedData.length > 0 ? (
                                (() => {
                                  // Sort so items of same group (discipline/type/ACS) stay together
                                  const sortedData = [
                                    ...filteredAndSortedData,
                                  ].sort((a, b) => {
                                    const keyA = `${a.discipline_name ?? ""}-${a.college_discipline_type ?? ""}-${a.user_type_name ?? ""}`;
                                    const keyB = `${b.discipline_name ?? ""}-${b.college_discipline_type ?? ""}-${b.user_type_name ?? ""}`;
                                    return keyA.localeCompare(keyB);
                                  });

                                  let serialNumber = (currentPage - 1) * 50 + 1;

                                  // Render rows with group headers
                                  return sortedData.map((item, index) => {
                                    return (
                                      <React.Fragment
                                        key={`${item.id}-${index}`}
                                      >
                                        <tr className="grouped-row">
                                          <td>{serialNumber++}</td>

                                          <td>
                                            <b>{item.vendor_name}</b> <br />
                                            <b>Phone:</b>
                                            {item.vendor_mobileno}
                                            <br />
                                            <b>Email:</b>
                                            {item.vendor_email}
                                            <br />
                                            <b>Address:</b>
                                            {item.vendor_address}
                                          </td>
                                          <td>
                                            {item.college_name
                                              ? item.college_name
                                              : "N/A"}
                                          </td>
                                          <td>
                                            {item.description ? (
                                              <span
                                                title={
                                                  item.description.length > 50
                                                    ? item.description
                                                    : ""
                                                }
                                                style={{
                                                  cursor:
                                                    item.description.length > 50
                                                      ? "help"
                                                      : "default",
                                                  display: "inline-block",
                                                  maxWidth: "200px",
                                                }}
                                              >
                                                {item.description.length > 50
                                                  ? `${item.description.substring(0, 50)}...`
                                                  : item.description}
                                              </span>
                                            ) : null}
                                          </td>
                                          <td>
                                            {item.college_id === "" ||
                                            item.college_id === 0
                                              ? "Done by University"
                                              : "Done by College"}
                                          </td>

                                          <td>
                                            <div className="d-flex justify-content-center gap-1">
                                              {item.document &&
                                                item.document[0]
                                                  ?.encryptedFile && (
                                                  <button
                                                    className="btn btn-sm btn-outline-primary btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                                    onClick={() =>
                                                      handleViewDocument(
                                                        item.document[0]
                                                          .encryptedFile,
                                                      )
                                                    }
                                                    title="View Document"
                                                  >
                                                    <i className="bi bi-eye-fill"></i>
                                                  </button>
                                                )}

                                              {item.college_id === 0 && (
                                                <>
                                                  <button
                                                    className="btn btn-sm btn-outline-warning btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                                    onClick={() =>
                                                      handleedit(item.id)
                                                    }
                                                    title="Edit"
                                                  >
                                                    <i class="fa fa-edit"></i>
                                                  </button>

                                                  <button
                                                    className="btn btn-sm btn-outline-danger btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                                    onClick={() =>
                                                      handleDeleteUser(item.id)
                                                    }
                                                    title="Delete"
                                                  >
                                                    <i className="fa fa-trash"></i>
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    );
                                  });
                                })()
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {totalPages > 1 && (
                          <nav aria-label="..." style={{ cursor: "pointer" }}>
                            <ul className="pagination justify-content-center">
                              <li
                                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                              >
                                <span
                                  className="page-link pgn-clr"
                                  onClick={handlePreviousPage}
                                >
                                  <i class="bi bi-arrow-left-circle-fill"></i>
                                </span>
                              </li>
                              <li className={`page-item`}>
                                <span
                                  className="page-link pgn-clr"
                                  onClick={() => handlePageChange(1)}
                                >
                                  1
                                </span>
                              </li>
                              {currentPage > 4 && (
                                <li className="page-item">
                                  <span className="page-link pgn-clr">...</span>
                                </li>
                              )}
                              {[...Array(totalPages - 1).keys()]
                                .slice(
                                  currentPage > 4 ? currentPage - 3 : 1,
                                  currentPage + 2,
                                )
                                .map((pageNumber) => (
                                  <li
                                    key={pageNumber}
                                    className={`page-item ${pageNumber + 1 === currentPage ? "act-clr" : ""}`}
                                  >
                                    <span
                                      className="page-link pgn-clr"
                                      onClick={() =>
                                        handlePageChange(pageNumber + 1)
                                      }
                                    >
                                      {pageNumber + 1}
                                    </span>
                                  </li>
                                ))}
                              {currentPage < totalPages - 3 && (
                                <li className="page-item">
                                  <span className="page-link pgn-clr">...</span>
                                </li>
                              )}

                              <li className={`page-item`}>
                                <span
                                  className="page-link pgn-clr"
                                  onClick={() => handlePageChange(totalPages)}
                                >
                                  {totalPages}
                                </span>
                              </li>

                              <li
                                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                              >
                                <span
                                  className="page-link pgn-clr"
                                  onClick={handleNextPage}
                                >
                                  <i class="bi bi-arrow-right-circle-fill"></i>
                                </span>
                              </li>
                            </ul>
                          </nav>
                        )}

                        {/*  Delete User */}
                        <div
                          className={`modal fade show ${isDeleteUser ? "d-block" : ""}`}
                          id="exampleModalCenter1"
                          tabIndex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalCenter1"
                          aria-model="true"
                        >
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-body">
                                <div className="modal-toggle-wrapper">
                                  <h4 className="text-center pb-2">
                                    Are you sure you want to delete?
                                  </h4>
                                  <p className="text-center">
                                    This action cannot be undone. Please confirm
                                    if you want to proceed with the deletion.
                                  </p>
                                  <div className="d-flex justify-content-center mt-3">
                                    <button
                                      className="btn btn-danger mx-2"
                                      onClick={() => handleDeleteSuccess()}
                                    >
                                      Delete
                                    </button>
                                    <button
                                      className="btn "
                                      style={{
                                        backgroundColor: "white",
                                        borderColor: "red",
                                        color: "black",
                                      }}
                                      data-bs-dismiss="modal"
                                      onClick={() => handleDeleteCancel()}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*  Delete User End */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Template>
      )}
      <PDFModal
        isOpen={isPDFModalOpen}
        onClose={handleClosePDFModal}
        pdfUrl={pdfUrl}
        fileName={pdfUrl ? "Document" : ""}
      />
    </>
  );
}
